import {POAcsId, POObject} from '@obj-models/POObject';

export class POIntegrationObject extends POObject {
  public acsIds: POAcsId[];
  public needToLoad: boolean;
}
